import getFlightDetailsByOrderItems from 'lib/flights/getFlightDetailsByOrderItems'
import { getInsuranceDestinationCountriesFromOrder } from 'lib/order/orderInsuranceUtils'
import { getPassportCardInsurableOrderSlice } from 'lib/order/orderPassportCardInsuranceUtils'
import { createSelector } from 'reselect'

/**
 * PassportCard variant of getInsuranceDestinationCountriesFromExistingOrder: the countries
 * are derived from the items a PassportCard policy covers, so cancelled history on the
 * order neither picks the vertical branch nor contributes a destination.
 */
const getPassportCardDestinationCountriesFromExistingOrder = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.cruise.cruiseOfferSnapshot,
  (state: App.State) => state.offer.offers,
  (state: App.State) => state.orders.flightDetails,
  (state: App.State) => state.experience.experiences,
  (order, cruiseOfferSnapshots, offers, flightDetails, experienceOffers): Array<string> => {
    if (!order) return []

    const insurableSlice = getPassportCardInsurableOrderSlice(order)
    const flightDetailsByOrderItems = getFlightDetailsByOrderItems(insurableSlice, flightDetails)
    return getInsuranceDestinationCountriesFromOrder(insurableSlice, cruiseOfferSnapshots, offers, flightDetailsByOrderItems, experienceOffers)
  },
)

export default getPassportCardDestinationCountriesFromExistingOrder
